import { TextRegular } from 'UiKit/typography';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import Tooltip from 'UiKit/tooltip';
import ActionButton from 'View/user/components/action-button';
import ColumnStatus from 'View/user/components/column-status';
import ColumnName from 'View/user/components/column-name';

import styles from './styles.module.css';

const buildTableList = (t) => {
  const accessPermission = getMenuPermissions('master-data', 'user');

  const tableList = [
    {
      name: t('tableColumnName'),
      key: 'name',
      width: 250,
      sortKey: 'name',
      component: ({ value, values }) => <ColumnName name={value} nip={values?.nip} />,
    },
    {
      name: t('tableColumnEmail'),
      key: 'email',
      width: 281,
      sortKey: 'email',
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnBrands'),
      key: 'brands',
      width: 250,
      component: ({ value }) => (
        <Tooltip label={value}>
          <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>
        </Tooltip>
      ),
    },
    {
      name: t('tableColumnPlatform'),
      key: 'platform',
      width: 250,
      component: ({ value }) => (
        <Tooltip label={value}>
          <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>
        </Tooltip>
      ),
    },
    {
      name: t('tableColumnRoleName'),
      key: 'role',
      width: 107,
      component: ({ value }) => <TextRegular className={`${styles['column__text']} ${styles['column__text--truncate']}`}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnHandphone'),
      key: 'handphone',
      width: 150,
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnDomicile'),
      key: 'domicile',
      width: 250,
      component: ({ value }) => <TextRegular className={styles['column__text']}>{value}</TextRegular>,
    },
    {
      name: t('tableColumnStatus'),
      key: 'isActive',
      width: 107,
      component: ({ value }) => <ColumnStatus isActive={value} />,
    },
  ];

  if (accessPermission?.isCanEdit || accessPermission?.isCanDelete) {
    tableList.push({
      name: t('tableColumnAction'),
      key: 'id',
      width: 150,
      position: 'center',
      rightSticky: 0,
      component: ({ value, values }) => <ActionButton value={value} rawData={values?.rawData} />,
    });
  }

  return tableList;
};

export default buildTableList;